import React, { useState, useMemo } from 'react';
import { FaSearch, FaEdit, FaDownload, FaLayerGroup } from 'react-icons/fa';
import { Form, InputGroup, Button } from 'react-bootstrap';

const Dashboard = ({
    profileContent,
    onSelectProfile,
    onExport,
    version,
    allVersions,
    setEditVersion
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const profiles = Object.keys(profileContent || {}).sort();

    const filteredProfiles = useMemo(() => {
        if (!searchTerm) return profiles;
        return profiles.filter(p =>
            p.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [profiles, searchTerm]);

    const getProfileBadges = (profileName) => {
        const profile = profileContent[profileName];
        if (!profile) return [];

        const badges = [];
        const reportTypes = ['advanced', 'dynamic', 'compact', 'vizapp'];

        reportTypes.forEach(rt => {
            if (profile[rt]) {
                const about = profile[rt]?.about;
                const hasAbout = about && (
                    Object.values(about.header || {}).some(v => v) ||
                    Object.values(about.text || {}).some(v => v)
                );
                const tips = profile[rt]?.tips;
                const hasTips = tips && tips.length > 0;

                if (hasAbout || hasTips) {
                    badges.push(rt);
                }
            }
        });

        return badges;
    };

    return (
        <div className="pfc-dashboard">
            {/* Main Header */}
            <div className="pfc-main-header">
                <div className="pfc-header-content">
                    <div className="pfc-title-group">
                        <div className="pfc-logo-icon">
                            <FaLayerGroup />
                        </div>
                        <div>
                            <h1 className="pfc-dashboard-title">Profile Manager</h1>
                            <p className="pfc-dashboard-subtitle">Manage report content & configurations</p>
                        </div>
                    </div>

                    <div className="pfc-header-controls">
                        <div className="pfc-version-wrapper">
                            <label>Version:</label>
                            <Form.Select
                                className="pfc-version-select"
                                onChange={(e) => setEditVersion(e.target.value)}
                                value={version || ''}
                            >
                                {Array.isArray(allVersions) && allVersions.map((v) => (
                                    <option key={v} value={v === 'live' ? '' : v}>
                                        {v === 'live' ? 'Live Production' : v}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                        <Button className="pfc-btn-export" onClick={onExport}>
                            <FaDownload /> Export Data
                        </Button>
                    </div>
                </div>
            </div>

            {/* Action Toolbar */}
            <div className="pfc-toolbar">
                <div className="pfc-search-wrapper">
                    <FaSearch className="pfc-search-icon" />
                    <input
                        type="text"
                        className="pfc-search-input"
                        placeholder="Search profiles..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>


            </div>

            {/* Grid Content */}
            <div className="pfc-content-area">
                <div className="pfc-grid-header">
                    <span>{filteredProfiles.length} Profiles Found</span>
                </div>

                <div className="pfc-grid">
                    {filteredProfiles.map(profileName => {
                        const badges = getProfileBadges(profileName);
                        return (
                            <div
                                key={profileName}
                                className="pfc-card"
                                onClick={() => onSelectProfile(profileName)}
                                tabIndex={0}
                                role="button"
                                aria-label={`Select ${profileName} profile`}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        onSelectProfile(profileName);
                                    }
                                }}
                            >
                                <div className="pfc-card-top">
                                    <div className="pfc-card-icon">
                                        {profileName.charAt(0).toUpperCase()}
                                    </div>
                                    <div className="pfc-card-edit">
                                        <FaEdit />
                                    </div>
                                </div>
                                <h3 className="pfc-card-title">{profileName}</h3>
                                <div className="pfc-card-tags">
                                    {badges.map(b => (
                                        <span key={b} className={`pfc-tag pfc-tag-${b}`}>{b}</span>
                                    ))}
                                    {badges.length === 0 && <span className="pfc-tag-empty">Empty</span>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
